import { createContext } from "react";


const InicioContext = createContext();

export default InicioContext;